module.exports = __webpack_public_path__ + "static/media/bg-our-food-mobile.2da3e7fb.jpg";